import {
  NOTIFICATION_ACTION_TYPES,
  createNotificationAction,
} from "shared/ui/notifications/notification-generic/base-parts/actions";
import { NotificationBase } from "@/modules/notifications/notification/base";
import { NotificationAuditionNote } from "@/modules/notifications/notification/note/audition";

import { NotificationI } from "@/lib/types/notification";
import Router from "@/helpers/router";

export const NotificationCampaignRejected = (
  props: NotificationI & { className?: string }
) => {
  const {
    id,
    campaign_id,
    campaign_name,
    is_seen,
    created_at,
    audition_notes,
    audition_approver_name,
    className,
  } = props;

  return (
    <NotificationBase
      id={id}
      isUnread={!is_seen}
      className={className}
      avatar={props}
      description={{
        text: (
          <>
            <b>{campaign_name}</b> did not approve your application for their
            campaign
          </>
        ),
        date: created_at,
        campaignName: campaign_name,
      }}
      message={{
        text: (
          <NotificationAuditionNote
            text={audition_notes}
            author={audition_approver_name}
          />
        ),
      }}
      actions={[
        createNotificationAction(
          NOTIFICATION_ACTION_TYPES.PRIMARY,
          "Try another campaign",
          () => {
            window.location.href = Router.marketplaceCampaign(campaign_id);
          }
        ),
      ]}
    />
  );
};
